import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SidenavService } from '@shared/services/sidenav.service';
import { SidebarItem } from '@shared/sidebaritem';
import { sidebarItems } from './menu';

@Component({
	selector: 'app-calculations',
	templateUrl: './calculations.component.html',
	styleUrl: './calculations.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CalculationsComponent implements OnInit {
	sidebarItems: SidebarItem[] = sidebarItems;

	constructor(private sidenavService: SidenavService) {}

	ngOnInit(): void {
		this.sidenavService.setMenuData(this.sidebarItems);
		this.sidenavService.closeRightPanel().catch((error) => {
			console.error('Error closing right panel:', error);
		});
	}
}
